var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"a-field__textarea",attrs:{"id":_vm.id,"name":_vm.name || _vm.id,"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }